





































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {StavkaDokumenta} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {formatPrice} from "@/utils/formatters";

@Component({})
export default class PotvrdaStavkiServisnihOperacija extends mixins(TableEditorsMixin) {
    @Prop({default: () => []}) stavke!: StavkaDokumenta[];
    @Prop({default: true}) prikaziPotvrdu!: boolean;
}
